import { type VariantProps, cva } from 'class-variance-authority';

export { default as Alert } from './Alert.vue';
export { default as AlertTitle } from './AlertTitle.vue';
export { default as AlertDescription } from './AlertDescription.vue';

export const alertVariants = cva(
	/*tw*/ 'flex flex-col items-start bg-white  p-3xl gap-3xl',
	{
		variants: {
			size: {
				floating:
					/*tw*/ 'border border-solid border-gray-300 rounded-xl shadow-xs ',
				fullWidth: /*tw*/ 'border-t border-solid border-gray-300',
			},
		},
		defaultVariants: {
			size: 'floating',
		},
	},
);

export type AlertVariants = VariantProps<typeof alertVariants>;
